import React from "react";
import { Box } from "@mui/material";
import TutorialsContent from "../../Main/Demo/TutorialsContent";

const VMHowToUse = () => {
  return (
    <Box sx={{ backgroundColor: "#ffffff", minHeight: "100%" }}>
      <TutorialsContent />
    </Box>
  );
};

export default VMHowToUse;
